var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var PackageGeneratorInspectorConfig = require("../packageGeneratorInspectorConfig.js");

var MountingHolePadGeneratorInteractionModel = require('./mountingHolePadGeneratorInteractionModel.js');

var StandoffSpacerGeneratorInteractionModel = function(IpcPthPadGeneratorData, userSettingsModel, showFootprintParams) {
    var self = this;

    MountingHolePadGeneratorInteractionModel.apply(this, arguments);

    this.bodyShape = this.shadow("bodyShape",
        function() {
            return self.data.bodyShape();
        },
        function(value) {
            return self.data.bodyShape(value);
        },
        [
            self.data.bodyShape
        ]
    );

    this.gender = this.shadow("gender",
        function() {
            return self.data.gender();
        },
        function(value) {
            return self.data.gender(value);
        },
        [
            self.data.gender
        ]
    );
};

lib_core.inherit(StandoffSpacerGeneratorInteractionModel, MountingHolePadGeneratorInteractionModel);
StandoffSpacerGeneratorInteractionModel.$class = 'StandoffSpacerGeneratorInteractionModel';
module.exports = StandoffSpacerGeneratorInteractionModel;

StandoffSpacerGeneratorInteractionModel.prototype.getInspectorElementForBodyShape = function() {
    var bodyShapesList = [];
    var bodyShapesAttr = cio_datamodel.IpcDataModel.PthComponentAttribute.type.ELECTRO_MECHANICAL.types.STANDOFF_SPACER.bodyShapes;

    for (var idx in bodyShapesAttr) {
        bodyShapesList.push([this.LCLZ(idx, bodyShapesAttr[idx]), bodyShapesAttr[idx]]);
    }

    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('bodyShape', 'Body Shape'), this.bodyShape, bodyShapesList)];
};

StandoffSpacerGeneratorInteractionModel.prototype.getThreadTypes = function() {
    var threadTypeList = [];
    var threadTypesAttr = cio_datamodel.IpcDataModel.PthComponentAttribute.threadTypes;

    for (var idx in threadTypesAttr) {
        threadTypeList.push(threadTypesAttr[idx].name);
    }

    return threadTypeList;
};

StandoffSpacerGeneratorInteractionModel.prototype.getThreadSizes = function(threadType) {
    var threadSizeList = [];
    var threadSizeKeys;

    if (threadType === cio_datamodel.IpcDataModel.PthComponentAttribute.threadTypes.ISO_METRIC.name) {
        threadSizeKeys = cio_datamodel.IpcDataModel.PthComponentAttribute.threadTypes.ISO_METRIC.sizes;
    } else if (threadType === cio_datamodel.IpcDataModel.PthComponentAttribute.threadTypes.ANSI.name) {
        threadSizeKeys = cio_datamodel.IpcDataModel.PthComponentAttribute.threadTypes.ANSI.sizes;
    }

    for (var key in threadSizeKeys) {
        threadSizeList.push(key);
    }
    
    return threadSizeList;
};

StandoffSpacerGeneratorInteractionModel.prototype.getThreadDesignations = function(threadType, threadSize) {
    var threadDesignationList = [];
    var threadDesignationKeys;

    if (threadType === cio_datamodel.IpcDataModel.PthComponentAttribute.threadTypes.ISO_METRIC.name) {
        threadDesignationKeys = cio_datamodel.IpcDataModel.PthComponentAttribute.threadTypes.ISO_METRIC.sizes[threadSize];
    } else if (threadType === cio_datamodel.IpcDataModel.PthComponentAttribute.threadTypes.ANSI.name) {
        threadDesignationKeys = cio_datamodel.IpcDataModel.PthComponentAttribute.threadTypes.ANSI.sizes[threadSize];
    }

    for (var key in threadDesignationKeys) {
        threadDesignationList.push(key);
    }
    
    return threadDesignationList;
};

StandoffSpacerGeneratorInteractionModel.prototype.getDefaultThreadSize = function(threadType) {
    if (threadType === cio_datamodel.IpcDataModel.PthComponentAttribute.threadTypes.ISO_METRIC.name) {
        return cio_datamodel.IpcDataModel.PthComponentAttribute.threadTypes.ISO_METRIC.defaultSize;
    } else if (threadType === cio_datamodel.IpcDataModel.PthComponentAttribute.threadTypes.ANSI.name) {
        return cio_datamodel.IpcDataModel.PthComponentAttribute.threadTypes.ANSI.defaultSize;
    }
};

StandoffSpacerGeneratorInteractionModel.prototype.initializeThreadInfo = function(threadTypeDataMember, threadSizeDataMember, threadDesignationDataMember, threadSizeList, threadDesignationList) {
    var self = this;

    // thread size
    threadSizeList(this.getThreadSizes(threadTypeDataMember()));
    threadSizeDataMember(this.getDefaultThreadSize(threadTypeDataMember()));
    
    // thread designation
    threadDesignationList(this.getThreadDesignations(threadTypeDataMember(), threadSizeDataMember()));
    threadDesignationDataMember(threadDesignationList()[0]);

    // update thread size list if thread type changes
    threadTypeDataMember.onChange(this, function(val) {
        threadSizeList(self.getThreadSizes(val));
        // set to 0 before assigning any value to it
        // this helps to fire onchange event of "threadSize" for the case of populating thread designations for different type but same thread size
        // onchange event does not trigger if previous and new value are same
        threadSizeDataMember(0);
        threadSizeDataMember(self.getDefaultThreadSize(threadTypeDataMember()));
    });

    // update thread designation list if thread size changes
    threadSizeDataMember.onChange(this, function(val) {
        threadDesignationList(self.getThreadDesignations(threadTypeDataMember(), val));
        threadDesignationDataMember(threadDesignationList()[0]);
    });
};

StandoffSpacerGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = MountingHolePadGeneratorInteractionModel.prototype.getInspectorElements.call(this).input_elements;
    
    imElements = imElements.concat(this.getInspectorElementForBodyShape());
    imElements = imElements.concat(this.getInspectorElementForBodyWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyHeight());
    imElements = imElements.concat(this.getInspectorElementForMapping());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
};
